import * as React from 'react';
import { EngineRenderers } from '@websky/core/src/renderProps';
import { SafeHtml } from '@websky/core/src/__fsd__/shared/ui';

const InsuranceCardOptions: EngineRenderers['renderInsuranceCardOptions'] = options => {
	return options.map(({ name }, index) =>
		index >= options.length - 2 ? (
			<>
				<SafeHtml key={index} tag="span" html={name} />
				{index === options.length - 2 ? `, ` : null}
			</>
		) : (
			<SafeHtml key={index} tag="li" html={name} />
		)
	);
};
export default InsuranceCardOptions;
